import axios from 'axios';

// Create an Axios instance — always use absolute backend URL so it works
// regardless of which port the frontend is served on (nginx, direct, etc.)
const getBaseURL = () => {
    return process.env.REACT_APP_API_URL || 'http://localhost:9050/api/v1';
};

const apiClient = axios.create({
    baseURL: getBaseURL(),
    headers: {
        'Content-Type': 'application/json',
    },
});

// Response interceptor to handle global errors (e.g., Token expired)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.error('Unauthorized - Token expired or invalid');
            // Here you can handle logging out the user or clearing local storage
            // localStorage.removeItem('token');
            // window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Request interceptor to attach JWT auth token
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Read the token from local storage
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default apiClient;
